export const PROVIDER_REFERRAL_FLAG_NAME: string = 'provider_referral_link_20201007';
export const PROVIDER_REFERRAL_PROGRAM_MVP_FLAG_NAME: string = 'provider_referral_program_mvp_20201021';
export const PROVIDER_REFERRAL_SHARE_COPY_A_FLAG_NAME = 'provider_referral_share_copy_a_20201118';
export const PROVIDER_REFERRAL_SHARE_COPY_B_FLAG_NAME = 'provider_referral_share_copy_b_20201118';
